import { sessionService } from '@/providers/services/auth/session';
import { USER_TYPE } from '@/utils/constants';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'data-lake',
})
export default class DataLake extends Vue {

    // --------------------------------------------------------
    // Properties

    private get session() {
        return sessionService.getSession();
    }

    private userTypeList: any = USER_TYPE;

    private userType: string = '';

    private dataLakeMenu: Array<{route: string, icon: string, label: string}> = [
        {
            route: '/data-lake/view',
            icon: 'dashboard',
            label: 'Data Lake',
        },
        {
            route: '/data-lake/data-access',
            icon: 'analytics',
            label: 'Data Access',
        },
    ];

    // ----------------------------------------------------------------
    // Hooks
    private created() {
        this.userType = this.$access.getUserType();
    }

    // ------------------------------------------------------------------
    // Actions


    // ---------------------------------------------------------------------
    // Methods

}
